class CountdownBadge extends HTMLElement {
  connectedCallback() {
    this.numberEl = this.querySelector('[data-days]');
    if (!this.numberEl) return;

    const target = this.dataset.target?.trim();
    if (!target) return;

    const targetMs = this._parseTarget(target);
    if (targetMs == null) return;

    this.targetMs = targetMs;
    this._update();

    const oneMinute = 60 * 1000;
    this._interval = setInterval(() => this._update(), oneMinute);
  }

  disconnectedCallback() {
    if (this._interval) clearInterval(this._interval);
  }

  _parseTarget(value) {
    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (isoMatch) {
      const [, y, m, d] = isoMatch;
      return Date.UTC(Number(y), Number(m) - 1, Number(d));
    }
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }

  _update() {
    const now = new Date();
    const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    const msPerDay = 24 * 60 * 60 * 1000;
    const days = Math.max(0, Math.ceil((this.targetMs - todayUtc) / msPerDay));

    if (this.numberEl.textContent !== String(days)) {
      this.numberEl.textContent = String(days);
    }
  }
}

if (!customElements.get('countdown-badge')) {
  customElements.define('countdown-badge', CountdownBadge);
}
